// ABC SEO/GEO — Block 2: Overview Dashboard. SEO + GEO side by side.
(function () {
  const { Icon } = window.SGIcons;
  const { Card, CardHead, Delta, Gauge, Sparkline, Bar, PageHead, RangeBtn } = window.SGKit;

  /* dual hero score — per domain: real when analyzed, else a Run-analysis CTA */
  function HeroScore({ kind, value, color, grad, title, desc, live, loading, scanning, onScan, caption, runLabel, scanningLabel }) {
    return (
      <Card style={{ padding: 24, display: 'flex', alignItems: 'center', gap: 22, animation: 'sg-rise 0.4s var(--sg-ease) both' }}>
        {value != null
          ? <Gauge value={value} color={color} size={150} suffix="/100" />
          : <div style={{ width: 150, height: 150, flex: 'none', borderRadius: '50%', border: '11px solid var(--sg-sunken)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 36, color: 'var(--sg-text-3)' }}>{loading ? '·' : '—'}</span>
            </div>}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
            <span style={{ width: 26, height: 26, borderRadius: 8, background: grad, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
              <Icon name={kind === 'geo' ? 'sparkles' : 'trending-up'} size={15} color="#fff" />
            </span>
            <span style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 600, fontSize: 17, color: 'var(--sg-text)' }}>{title}</span>
            {live && <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.04em', color: 'var(--sg-green)', background: 'var(--sg-green-50)', padding: '2px 8px', borderRadius: 'var(--sg-radius-pill)' }}>● LIVE</span>}
          </div>
          <p style={{ margin: '0 0 14px', fontSize: 13, color: 'var(--sg-text-2)', lineHeight: 1.5 }}>{desc}</p>
          {loading
            ? <span style={{ fontSize: 12, color: 'var(--sg-text-3)' }}>Checking…</span>
            : onScan
              ? <button onClick={onScan} disabled={scanning}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 7, height: 36, padding: '0 15px', border: 'none', borderRadius: 'var(--sg-radius-pill)', cursor: scanning ? 'wait' : 'pointer',
                    fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 13, color: '#fff', background: grad, boxShadow: '0 3px 10px rgba(124,58,237,0.28)' }}>
                  <Icon name={kind === 'geo' ? 'sparkles' : 'activity'} size={15} color="#fff" /> {scanning ? scanningLabel : runLabel}
                </button>
              : <span style={{ fontSize: 12, color: 'var(--sg-text-3)' }}>{caption}</span>}
        </div>
      </Card>
    );
  }

  /* metric stat card with sparkline */
  const STATS = [
    { label: 'Organic keywords', value: '1,284', icon: 'key', color: 'var(--sg-blue-500)', delta: '6%', dir: 'up', spark: [40, 44, 43, 48, 52, 55, 58, 62] },
    { label: 'Monthly traffic', value: '8,430', icon: 'trending-up', color: 'var(--sg-blue-500)', delta: '3%', dir: 'up', spark: [60, 58, 62, 61, 64, 63, 66, 68] },
    { label: 'Backlinks', value: '412', icon: 'link', color: 'var(--sg-blue-500)', delta: '12', dir: 'up', spark: [30, 33, 35, 34, 38, 40, 44, 47] },
    { label: 'AI mentions', value: '37', icon: 'sparkles', color: 'var(--sg-violet-600)', delta: '9', dir: 'up', spark: [12, 15, 14, 18, 22, 28, 31, 37], ai: true },
  ];
  function StatCard({ s }) {
    return (
      <Card style={{ padding: 18 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 14 }}>
          <span style={{ width: 30, height: 30, borderRadius: 9, background: s.ai ? 'var(--sg-violet-50)' : 'var(--sg-blue-50)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name={s.icon} size={16} color={s.color} />
          </span>
          <span style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--sg-text-2)' }}>{s.label}</span>
          {s.live && <span style={{ marginLeft: 'auto', fontSize: 9.5, fontWeight: 700, letterSpacing: '0.04em', color: 'var(--sg-green)', background: 'var(--sg-green-50)', padding: '2px 7px', borderRadius: 'var(--sg-radius-pill)' }}>● LIVE</span>}
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 10 }}>
          <div>
            <div className="sg-tnum" style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 30, letterSpacing: '-0.02em', color: 'var(--sg-text)', lineHeight: 1 }}>{s.value}</div>
            <div style={{ marginTop: 10 }}>
              {s.live || !s.delta
                ? <span style={{ fontSize: 11.5, color: 'var(--sg-text-3)' }}>{s.sub}</span>
                : <Delta dir={s.dir}>{s.delta}</Delta>}
            </div>
          </div>
          {s.spark && <Sparkline data={s.spark} color={s.color} w={84} h={36} />}
        </div>
      </Card>
    );
  }

  /* real Search Console performance trend — daily clicks + impressions */
  function DualTrend({ clicks, impressions }) {
    const has = Array.isArray(clicks) && clicks.length > 1;
    if (!has) {
      return (
        <Card>
          <CardHead title="Search performance trend" sub="Daily clicks & impressions from Search Console" />
          <div style={{ padding: '40px 20px', textAlign: 'center', fontSize: 13, color: 'var(--sg-text-2)' }}>No Search Console data for this domain yet.</div>
        </Card>
      );
    }
    const W = 620, H = 210, pad = 14;
    const norm = (arr) => { const mx = Math.max(1, ...arr); return arr.map((v) => v / mx); };
    const nc = norm(clicks), ni = norm(impressions || clicks);
    const x = (i) => pad + (i * (W - pad * 2)) / (clicks.length - 1);
    const y = (v) => H - pad - v * (H - pad * 2);
    const path = (arr) => arr.map((v, i) => `${i ? 'L' : 'M'}${x(i).toFixed(1)},${y(v).toFixed(1)}`).join(' ');
    return (
      <Card>
        <CardHead title="Search performance trend" sub="Daily clicks & impressions from Search Console · last 28 days"
          right={(
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12.5, fontWeight: 600, color: 'var(--sg-text-2)' }}><span style={{ width: 12, height: 3, borderRadius: 2, background: 'var(--sg-blue-500)' }} /> Clicks</span>
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12.5, fontWeight: 600, color: 'var(--sg-text-2)' }}><span style={{ width: 12, height: 3, borderRadius: 2, background: 'var(--sg-violet-400, #A78BFA)' }} /> Impressions</span>
              <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.04em', color: 'var(--sg-green)', background: 'var(--sg-green-50)', padding: '2px 8px', borderRadius: 'var(--sg-radius-pill)' }}>● LIVE</span>
            </div>
          )} />
        <div style={{ padding: '12px 16px 4px' }}>
          <svg viewBox={`0 0 ${W} ${H}`} width="100%" height="210" preserveAspectRatio="none" style={{ display: 'block' }}>
            <defs><linearGradient id="sgClkA" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#2563EB" stopOpacity="0.16" /><stop offset="100%" stopColor="#2563EB" stopOpacity="0" /></linearGradient></defs>
            {[0, 1, 2, 3].map((g) => <line key={g} x1={pad} x2={W - pad} y1={pad + g * (H - pad * 2) / 3} y2={pad + g * (H - pad * 2) / 3} stroke="var(--sg-border)" strokeWidth="1" strokeDasharray="3 4" />)}
            <path d={`${path(nc)} L${x(nc.length - 1)},${H - pad} L${x(0)},${H - pad} Z`} fill="url(#sgClkA)" />
            <path d={path(ni)} fill="none" stroke="var(--sg-violet-400, #A78BFA)" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" strokeDasharray="2 3" opacity="0.8" />
            <path d={path(nc)} fill="none" stroke="var(--sg-blue-500)" strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" />
            <circle cx={x(nc.length - 1)} cy={y(nc[nc.length - 1])} r="4.5" fill="var(--sg-blue-500)" stroke="#fff" strokeWidth="2.5" />
          </svg>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 14px 10px', fontSize: 11, color: 'var(--sg-text-3)' }}>
            <span>28d ago</span><span>18d</span><span>9d</span><span>Today</span>
          </div>
        </div>
      </Card>
    );
  }

  /* AI engine visibility — REAL per-domain mention-rate from the GEO scan */
  const ENGINE_META = {
    chatgpt: { name: 'ChatGPT', tag: 'C', color: '#10A37F' },
    gemini: { name: 'Gemini', tag: 'G', color: '#8E75F0' },
    perplexity: { name: 'Perplexity', tag: 'P', color: '#20808D' },
    claude: { name: 'Claude', tag: 'C', color: '#D97757' },
    copilot: { name: 'Copilot', tag: 'C', color: '#0A6ED1' },
  };
  function EnginePanel({ byPlatform }) {
    const keys = byPlatform ? Object.keys(byPlatform) : [];
    return (
      <Card>
        <CardHead ai title="AI engine visibility" sub="How often each AI engine mentions you, for relevant prompts" />
        <div style={{ padding: '6px 20px 14px' }}>
          {keys.length === 0
            ? <div style={{ padding: '14px 0', fontSize: 13, color: 'var(--sg-text-2)' }}>Run an AI-visibility scan (the GEO score above) to see your real mention rate in each engine.</div>
            : keys.map((k, i) => {
              const m = ENGINE_META[k] || { name: k, tag: (k[0] || '?').toUpperCase(), color: '#8892A6' };
              const p = byPlatform[k] || {};
              const rate = p.mention_rate ?? 0;
              return (
                <div key={k} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '11px 0', borderBottom: i < keys.length - 1 ? '1px solid var(--sg-border)' : 'none' }}>
                  <span style={{ width: 28, height: 28, borderRadius: 8, background: m.color, flex: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 13, fontFamily: 'var(--sg-font-display)' }}>{m.tag}</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--sg-text)' }}>{m.name}</span>
                      <span className="sg-tnum" style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--sg-violet-700)' }}>{rate}% <span style={{ color: 'var(--sg-text-3)', fontWeight: 500 }}>({p.mentioned ?? 0}/{p.total ?? 0})</span></span>
                    </div>
                    <Bar pct={rate} delay={0.1 + i * 0.06} />
                  </div>
                </div>
              );
            })}
        </div>
      </Card>
    );
  }

  /* what to fix first — REAL: failed/warning checks from the SEO audit + low-
     mention AI engines from the GEO scan, for the selected domain. */
  function buildFixes(seoChecks, geoByPlatform) {
    const out = [];
    const order = { fail: 0, warning: 1 };
    (seoChecks || []).filter((c) => c.status === 'fail' || c.status === 'warning')
      .sort((a, b) => (order[a.status] - order[b.status]))
      .forEach((c) => out.push({
        kind: 'seo', high: c.status === 'fail', t: c.name,
        b: c.recommendation || c.details || 'Fix this to improve your technical SEO.',
        tag: (c.status === 'fail' ? 'HIGH' : 'MED') + ' · SEO',
      }));
    Object.keys(geoByPlatform || {}).forEach((k) => {
      const p = geoByPlatform[k] || {}; const name = (ENGINE_META[k] || {}).name || k;
      if ((p.mention_rate ?? 100) < 60) {
        out.push({ kind: 'geo', high: (p.mention_rate ?? 0) < 30, t: `Get mentioned more in ${name}`,
          b: `You're surfaced in only ${p.mention_rate ?? 0}% of relevant prompts (${p.mentioned ?? 0}/${p.total ?? 0}). Add structured data, FAQs and citations.`,
          tag: ((p.mention_rate ?? 0) < 30 ? 'HIGH' : 'MED') + ' · GEO' });
      }
    });
    return out;
  }
  function FixRow({ f, last }) {
    const [h, setH] = React.useState(false);
    const c = f.kind === 'geo' ? 'var(--sg-violet-600)' : (f.high ? 'var(--sg-red)' : 'var(--sg-amber)');
    const tagc = f.kind === 'geo' ? 'var(--sg-violet-700)' : 'var(--sg-blue-600)';
    const tagbg = f.kind === 'geo' ? 'var(--sg-violet-100)' : 'var(--sg-blue-50)';
    return (
      <div onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
        style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '15px 20px', borderBottom: last ? 'none' : '1px solid var(--sg-border)',
          background: h ? 'var(--sg-sunken)' : 'transparent', transition: 'background 140ms var(--sg-ease)' }}>
        <span style={{ width: 9, height: 9, borderRadius: '50%', background: c, flex: 'none' }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--sg-text)' }}>{f.t}</div>
          <div style={{ fontSize: 12.5, color: 'var(--sg-text-2)', marginTop: 2 }}>{f.b}</div>
        </div>
        <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.04em', color: tagc, background: tagbg, padding: '4px 9px', borderRadius: 'var(--sg-radius-pill)', flex: 'none' }}>{f.tag}</span>
      </div>
    );
  }

  function Dashboard() {
    const { perf, site, prettySite } = window.SGLive.useLive();
    const dom = site ? prettySite(site) : '';
    const t = window.SGLive.transforms;

    // Per-domain scores: each from the latest audit FOR THE SELECTED DOMAIN.
    // undefined = loading, null = never analyzed (show Run CTA), object = real.
    const [seoA, setSeoA] = React.useState(undefined);
    const [geoA, setGeoA] = React.useState(undefined);
    const [scanningSeo, setScanningSeo] = React.useState(false);
    const [scanningGeo, setScanningGeo] = React.useState(false);

    React.useEffect(() => {
      if (!dom) return undefined;
      setSeoA(undefined); setGeoA(undefined);
      window.SGLive.fetchLatestAudit(dom, 'seo').then((a) => setSeoA(a || null));
      window.SGLive.fetchLatestAudit(dom, 'geo').then((a) => setGeoA(a || null));
      return undefined;
    }, [dom]);

    const runSeo = async () => {
      if (!dom) return; setScanningSeo(true);
      try { await window.SGLive.runSeoAudit(dom); const a = await window.SGLive.fetchLatestAudit(dom, 'seo'); setSeoA(a || null); }
      finally { setScanningSeo(false); }
    };
    const runGeo = async () => {
      if (!dom) return; setScanningGeo(true);
      try { await window.SGLive.runGeoScan(dom); const a = await window.SGLive.fetchLatestAudit(dom, 'geo'); setGeoA(a || null); }
      finally { setScanningGeo(false); }
    };

    const seoScore = seoA ? seoA.score : null;
    const geoScore = geoA ? geoA.score : null;
    const seoDesc = seoScore != null
      ? (seoScore >= 80 ? 'Your site is in good technical shape for Google. A few fixes will push you higher.'
        : seoScore >= 50 ? 'Solid foundation with clear technical issues to fix — see the task list.'
        : 'Several technical SEO issues are holding you back. Start with the high-impact fixes.')
      : `We haven’t crawled ${dom || 'this domain'} yet — run a quick audit to score its technical SEO.`;
    const geoDesc = geoScore != null
      ? (geoScore >= 50 ? 'AI assistants mention you for relevant prompts — keep reinforcing it.'
        : geoScore > 0 ? 'AI assistants rarely surface you yet — big upside in AI search.'
        : 'AI assistants don’t mention you at all yet — a clear opportunity to capture.')
      : `We haven’t checked ${dom || 'this domain'} in AI engines yet — run a scan to score its AI visibility.`;

    // Real per-domain AI-mention totals from the GEO scan (else a Run prompt).
    const byPlatform = (geoA && geoA.raw && geoA.raw.by_platform) || null;
    const aiMentioned = byPlatform ? Object.keys(byPlatform).reduce((a, k) => a + (byPlatform[k].mentioned || 0), 0) : null;
    const aiTotal = byPlatform ? Object.keys(byPlatform).reduce((a, k) => a + (byPlatform[k].total || 0), 0) : null;
    const aiStat = { label: 'AI mentions', value: aiMentioned != null ? String(aiMentioned) : '—', icon: 'sparkles', color: 'var(--sg-violet-600)', sub: aiTotal != null ? `of ${aiTotal} prompts` : 'run a scan', live: aiMentioned != null, ai: true };

    // Live Search Console stats per domain + real AI mentions.
    const stats = perf ? [
      { label: 'Search clicks', value: perf.totals.clicks.toLocaleString(), icon: 'trending-up', color: 'var(--sg-blue-500)', sub: 'last 28 days', spark: t.clicksSeries(perf), live: true },
      { label: 'Impressions', value: perf.totals.impressions.toLocaleString(), icon: 'activity', color: 'var(--sg-blue-500)', sub: 'last 28 days', spark: t.imprSeries(perf), live: true },
      { label: 'Avg. position', value: (Math.round(perf.totals.position * 10) / 10).toFixed(1), icon: 'list-ordered', color: 'var(--sg-blue-500)', sub: 'lower is better', spark: t.posSeries(perf).map((v) => -v), live: true },
      aiStat,
    ] : [
      { label: 'Search clicks', value: '—', icon: 'trending-up', color: 'var(--sg-blue-500)', sub: 'connect Search Console', live: true },
      { label: 'Impressions', value: '—', icon: 'activity', color: 'var(--sg-blue-500)', sub: 'connect Search Console', live: true },
      { label: 'Avg. position', value: '—', icon: 'list-ordered', color: 'var(--sg-blue-500)', sub: 'connect Search Console', live: true },
      aiStat,
    ];
    const fixes = buildFixes(seoA && seoA.raw && seoA.raw.checks, byPlatform);
    const siteLabel = dom || 'your site';
    return (
      <div style={{ maxWidth: 1180, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 20 }}>
        <PageHead eyebrow="Overview" title="Overview" sub={`Your complete SEO + AI-visibility snapshot for ${siteLabel}.`} right={<RangeBtn />} />

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <HeroScore kind="seo" value={seoScore} color="var(--sg-blue-500)" grad="var(--sg-grad-brand)"
            title="SEO Health Score" desc={seoDesc} caption="From a full technical crawl of your site"
            live={seoScore != null} loading={seoA === undefined}
            scanning={scanningSeo} scanningLabel="Crawling your site…" runLabel="Run site audit"
            onScan={seoA === null ? runSeo : undefined} />
          <HeroScore kind="geo" value={geoScore} color="var(--sg-violet-600)" grad="var(--sg-grad-violet)"
            title="GEO AI-Visibility Score" desc={geoDesc} caption="Scored across ChatGPT · Gemini · Perplexity"
            live={geoScore != null} loading={geoA === undefined}
            scanning={scanningGeo} scanningLabel="Scanning AI engines…" runLabel="Run AI-visibility scan"
            onScan={geoA === null ? runGeo : undefined} />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}>
          {stats.map((s) => <StatCard key={s.label} s={s} />)}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1.55fr 1fr', gap: 20, alignItems: 'start' }}>
          <DualTrend clicks={perf ? t.clicksSeries(perf) : null} impressions={perf ? t.imprSeries(perf) : null} />
          <EnginePanel byPlatform={byPlatform} />
        </div>

        <Card>
          <CardHead title="What to fix first" sub={fixes.length ? `Real issues for ${dom || 'your site'} — biggest wins on top` : 'Run a site audit and AI-visibility scan to get your prioritized fixes'} />
          <div>{fixes.length === 0
            ? <div style={{ padding: '22px 20px', fontSize: 13, color: 'var(--sg-text-2)' }}>{(seoA === null || geoA === null) ? 'Run the audit and scan above to see real, prioritized fixes for this domain.' : 'No issues found — nice. 🎉'}</div>
            : fixes.map((f, i) => <FixRow key={i} f={f} last={i === fixes.length - 1} />)}</div>
        </Card>
      </div>
    );
  }

  window.SGDashboard = Dashboard;
})();
